module.exports = __webpack_public_path__ + "static/media/Acheive13.807ce87d.jpeg";